import OverlayHeading from './overlay-heading'
export default OverlayHeading



// WEBPACK FOOTER //
// ./src/components/overlay-heading/index.js